import React from "react";

const StepTwo = () => {
  return (
    <div>
      <h1>Step 2</h1>
    </div>
  );
};

export default StepTwo;
